import { Icon } from "armstrong-react";
import React from "react";
import { Editor } from "slate";
import { ToolbarOptions } from "..";
import { BLOCKS, MARKS } from "../html";
import { ToggleLinkButton } from "./link/toggleLinkButton";
import { StylePicker } from "./stylePicker";
import { ToggleButton } from "./toggleButton";
import { TogglePriceCalculatorButton } from "./togglePriceCalculatorButton";
import { ToggleSnippetsButton } from "./toggleSnippetsButton";

import "./toolbar.scss";

export interface IToolbarProps {
  editorRef: Editor;
}
export interface OwnProps {
  toolbarOptions: ToolbarOptions[];
}

type Props = IToolbarProps & OwnProps;

/**
 * Formatting toolbar for Slate text editor
 */
export class Toolbar extends React.Component<Props> {
  public render() {
    const { editorRef, toolbarOptions } = this.props;

    if (!editorRef) {
      return null;
    }

    return (
      <div className="slate-toolbar">
        {toolbarOptions.indexOf(ToolbarOptions.Minimal) !== -1 && (
          <>
            <ToggleButton editorRef={editorRef} type={MARKS.BOLD.type}>
              <Icon icon={Icon.Icomoon.bold2} />
            </ToggleButton>

            <ToggleButton editorRef={editorRef} type={MARKS.UNDERLINE.type}>
              <Icon icon={Icon.Icomoon.underline2} />
            </ToggleButton>

            <ToggleButton editorRef={editorRef} type={MARKS.ITALIC.type}>
              <Icon icon={Icon.Icomoon.italic2} />
            </ToggleButton>

            <ToggleButton editorRef={editorRef} type={BLOCKS.QUOTE.type}>
              <Icon icon={Icon.Icomoon.quotesLeft} />
            </ToggleButton>
          </>
        )}

        {toolbarOptions.indexOf(ToolbarOptions.Headings) !== -1 &&
          <StylePicker editorRef={editorRef} />
        }
        {toolbarOptions.indexOf(ToolbarOptions.Minimal) !== -1 &&
          <ToggleLinkButton editorRef={editorRef} />
        }
        {toolbarOptions.indexOf(ToolbarOptions.PriceCalculator) !== -1 &&
          <TogglePriceCalculatorButton editorRef={editorRef} />
        }
        {toolbarOptions.indexOf(ToolbarOptions.MessageSnippets) !== -1 &&
          <ToggleSnippetsButton editorRef={editorRef} />
        }
      </div>
    );
  }
}
